import type { RouteRecordRaw } from 'vue-router'

import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'

import redirectIfWebview from '../webviews/middleware/redirectIfWebview'

import { OUTLET } from './routes-names'

// We expose the outlet pages on both the standard URL space and the webview
// namespace via `generateWebviewRoutes`.
export default (): RouteRecordRaw[] => {
  const outletRoutes: RouteRecordRaw[] = [
    {
      path: 'outlet',
      name: OUTLET.HOME,
      component: () =>
        import('~/scopes/outlet/pages/OutletHome/OutletHome.vue'),
      meta: {
        layout: false,
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'outlet/:slug',
      name: OUTLET.CATEGORY,
      component: () =>
        import('~/scopes/outlet/pages/OutletCategory/OutletCategory.vue'),
      meta: {
        layout: false,
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'outlet/p/:id',
      name: OUTLET.DETAIL,
      component: () =>
        import('~/scopes/outlet/pages/OutletDetail/OutletDetail.vue'),
      meta: {
        layout: false,
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
  ]

  const webviewOutletRoutes = generateWebviewRoutes(outletRoutes)

  return [...outletRoutes, ...webviewOutletRoutes]
}
